import api from './api';

/**
 * Fetch monthly sensor averages from the backend API.
 * @param {Object} params
 * @param {number} params.year - Target year (e.g. 2026)
 * @param {number} [params.month] - Optional month (1-12)
 * @param {string} [params.zone] - Optional zone filter (e.g. "living room")
 * @returns {Promise<Array>} Array of monthly average records
 */
export const getMonthlyAverages = async ({ year, month, zone } = {}) => {
    const params = {};
    if (year !== undefined && year !== null && year !== '') {
        params.year = year;
    }
    if (month !== undefined && month !== null && month !== '' && month !== 'all') {
        params.month = parseInt(month, 10);
    }
    if (zone !== undefined && zone !== null && zone !== '' && zone !== 'all') {
        params.zone = zone;
    }

    const response = await api.get('/sensor/monthly-averages', { params });
    return response.data;
};

/**
 * Fetch latest sensor data to discover available zones.
 * @returns {Promise<Array<string>>} Sorted list of zone names
 */
export const getAvailableZones = async () => {
    try {
        const response = await api.get('/sensor/latest');
        const zones = [...new Set(response.data.map((item) => item.zone))]
            .filter(Boolean)
            .sort();
        return zones;
    } catch (err) {
        console.error('Failed to fetch available zones:', err);
        return [];
    }
};
